<template>
  <Teleport to="body">
  <div
    :id="id"
    class="hs-overlay hidden size-full fixed top-0 start-0 overflow-x-hidden overflow-y-auto pointer-events-none"
    role="dialog"
    tabindex="-1"
  >
    <div class="flex items-center min-h-full">
    <div
      :class="`hs-overlay-open:opacity-100 hs-overlay-open:duration-500 opacity-0 transition-all ${sizes[size]} `"
    >
      <div
        class="transition transform hover:-translate-y-1 flex flex-col bg-white border border-gray-400 shadow-sm rounded-xl pointer-events-auto dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]"
      >
        <div
          class="flex justify-between items-center px-6 py-4 rounded-t-xl border-b dark:border-gray-700"
          :class="headerColors[headerColor].header"
          :style="headerColors[headerColor].headerStyle"
        >
          <slot name="modal-title">
            <div class="flex flex-col">
              <h3
                id="title-modal"
                class="text-base font-bold text-gray-800"
              >
                {{ title }}
              </h3>
              <p class="text-xs text-gray-600 mt-0.5">{{ subTitle }}</p>
            </div>
          </slot>
          <button
            v-if="props.showClose"
            type="button"
            class="flex justify-center items-center size-7 text-sm font-semibold rounded-full border cursor-pointer border-transparent hover:bg-black/10 disabled:opacity-50 disabled:pointer-events-none"
            :class="headerColors[headerColor].closeBtn"
            @click="solicitarCierre"
          >
            <span class="sr-only">Cerrar modal</span>
            <XMarkIcon></XMarkIcon>
          </button>
        </div>
        <div class="p-4 overflow-y-auto">
          <slot name="modal-body"> </slot>
        </div>
        <div
          v-if="$props.showFooter"
          id="footer-modal"
          class="flex justify-end items-center gap-x-2 py-3 px-4"
        >
          <ButtonDefault
            v-if="props.button && props.showClose"
            color="gray"
            @click="solicitarCierre"
            >
            Cerrar
          </ButtonDefault>
          <slot name="modal-footer"></slot>
        </div>
      </div>
    </div>
    </div>
  </div>
  </Teleport>
</template>
<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { closeModal } from '@/modules/Core/usings/generales.js'
import { onUnmounted, type PropType } from 'vue'
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: false,
    default: ''
  },
  subTitle: {
    type: String,
    required: false,
    default: ''
  },
  size: {
    type: String as PropType<'sm' | 'md' | 'lg' | 'xl' | 'full'>,
    required: false,
    default: 'sm'
  },
  button: {
    type: Boolean,
    required: false,
    default: true
  },
  showClose: {
    type: Boolean,
    required: false,
    default: true
  },
  showFooter: {
    type: Boolean,
    required: false,
    default: true
  },
  fncOnRequestClose: {
    type: Function as PropType<() => void>,
    required: false,
    default: undefined
  },
  fncOnClose: {
    type: Function,
    required: false,
    default: null
  },
  headerColor: {
    type: String as PropType<'gray' | 'yellow' | 'red' | 'blue'>,
    required: false,
    default: 'gray'
  }
})
const sizes = {
  sm: 'sm:max-w-lg sm:w-full m-3 sm:mx-auto',
  md: 'md:max-w-2xl md:w-full m-3 md:mx-auto',
  lg: 'lg:max-w-6xl lg:w-full m-3 lg:mx-auto',
  xl: 'xl:max-w-7xl xl:w-full m-3 xl:mx-auto',
  full: 'w-[95vw] max-w-[95vw] m-3 mx-auto'
}

const headerColors = {
  gray:   { header: 'bg-slate-100 border-slate-200', headerStyle: {}, closeBtn: 'text-slate-600' },
  yellow: { header: 'bg-yellow-100 border-yellow-200', headerStyle: {}, closeBtn: 'text-yellow-700' },
  red:    { header: 'bg-red-100 border-red-200', headerStyle: {}, closeBtn: 'text-red-700' },
  blue:   { header: 'bg-blue-100 border-blue-200', headerStyle: { backgroundColor: '#dbeafe' }, closeBtn: 'text-blue-700' },
}

function solicitarCierre() {
  if (props.fncOnRequestClose) props.fncOnRequestClose()
  else closeModal(props.id, props.fncOnClose as () => void)
}

onUnmounted(() => {
  const backdrop = document.getElementById(`${props.id}-backdrop`)
  if (backdrop) backdrop.remove()
  const remaining = document.querySelectorAll('.hs-overlay-backdrop').length
  if (remaining === 0) document.body.style.overflow = ''
})
</script>
